import React, { useEffect, useMemo } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";

import ErrorMessage from "@/components/atoms/ErrorMessage";
import Header from "@/components/molecules/Header";
import SucessMessage from "@/components/atoms/SucessMessage";
import Button from "@/components/atoms/Buttons/Button";
import i18n from "@/translate/i18n";
import { useTransactionData } from "@/context/transactionContext";

const TIME_TO_REDIRECT = 5000;

const isValidUrl = (urlString) => {
  if (!urlString) return false;
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

function DepositStatus1xbet() {
  const location = useLocation();
  const history = useHistory();
  const { id, token } = useParams();

  const dataFromState = location.state?.data;
  const { transactionData: dataFromContext } = useTransactionData();

  const transactionData = dataFromState || dataFromContext;

  const validationNeeded = false;

  const hasValidRedirectUrl = useMemo(
    () => isValidUrl(transactionData?.redirect_url),
    [transactionData?.redirect_url],
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        transactionData?.status === "completed" &&
        !validationNeeded &&
        hasValidRedirectUrl
      ) {
        window.location.href = transactionData.redirect_url;
      }
    }, TIME_TO_REDIRECT);
    return () => clearTimeout(timer);
  }, [transactionData, validationNeeded, hasValidRedirectUrl]);

  if (!transactionData?.id) {
    return (
      <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen" />
    );
  }

  return (
    <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen overflow-x-hidden">
      <div className="flex flex-col justify-between items-center w-[500px] rounded-[20px] overflow-hidden text-center">
        <Header
          showAmount
          transactionData={transactionData}
          title={
            transactionData?.status === "completed"
              ? i18n.t("confirmation.titleSucess")
              : i18n.t("confirmation.titleFail")
          }
        />
        {transactionData?.status === "completed" ? (
          <SucessMessage
            is1xbet
            title={i18n.t("confirmation.congrats")}
            subtitle={i18n.t("confirmation.content")}
            handleClick={
              hasValidRedirectUrl
                ? () => window.location.replace(transactionData?.redirect_url)
                : null
            }
          />
        ) : transactionData?.status === "pending" ? (
          <SucessMessage
            is1xbet
            title={i18n.t("confirmation.confirmedTransaction")}
            messageDescription={i18n.t("confirmation.pendingMessage")}
            handleClick={
              hasValidRedirectUrl
                ? () => window.location.replace(transactionData?.redirect_url)
                : null
            }
          />
        ) : (
          <ErrorMessage
            isExpired={transactionData?.status === "expired"}
            transactionData={transactionData}
            handleClick={() =>
              history.replace(`/${id}/${token}${history.location.search}`)
            }
          >
            {i18n.t([
              `error.transaction.${transactionData?.message}`,
              "error.transaction.unspecific",
            ])}
          </ErrorMessage>
        )}
        {validationNeeded && (
          <Button type="button" handleClick={() => {}}>
            {i18n.t("confirmation.validateIdentityNow")}
          </Button>
        )}
      </div>
    </div>
  );
}

export default DepositStatus1xbet;
